import AiGradientSpinner from '@cobliteam/ui-business/components/AiGradientSpinner';

const SPINNER_GRADIENT = 'linear-gradient(135deg, #001BB8 0%, #9847EE 100%)';
const BG_COLOR = '#F8F7FD';
const BORDER_GRADIENT = 'linear-gradient(90deg, #001BB8 0%, #9847EE 100%)';

const AiRecommendationBannerSkeleton = () => (
  <div
    className='flex w-full items-center gap-4 rounded-2xl px-5 py-4'
    style={{
      background: BG_COLOR,
      border: '1px solid transparent',
      backgroundImage: `linear-gradient(${BG_COLOR}, ${BG_COLOR}), ${BORDER_GRADIENT}`,
      backgroundOrigin: 'border-box',
      backgroundClip: 'padding-box, border-box',
    }}
  >
    <AiGradientSpinner size='sm' />

    {/* Text */}
    <div className='flex flex-col gap-0.5'>
      <span className='font-semibold text-sm' style={{ background: SPINNER_GRADIENT, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
        Analisando sua frota com IA
      </span>
      <span className='text-neutral-400 text-xs'>Isso pode levar alguns segundos...</span>
    </div>
  </div>
);

export default AiRecommendationBannerSkeleton;
